import { Users } from "lucide-react";
import { ErrorCard } from "../layout/ErrorCard";
import { RealTimeUpdater } from "@/components/ui/interactive/RealTimeUpdater";
import { DynamicCard } from "@/components/ui/interactive/DynamicCard";

interface ClientStatusCardsWidgetProps {
  clients: any[];
  clientStatuses: any[];
  isLoading: boolean;
  error: any;
  onRetry: () => void;
}

export const ClientStatusCardsWidget = ({ 
  clients, 
  clientStatuses, 
  isLoading, 
  error, 
  onRetry 
}: ClientStatusCardsWidgetProps) => {
  return (
    <section>
      <h2 className="text-xl font-bold text-slate-800 mb-6 flex items-center gap-2">
        <Users className="w-5 h-5" />
        حالات العملاء
        {isLoading && <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />}
      </h2>
      {error ? (
        <ErrorCard onRetry={onRetry} />
      ) : (
        <RealTimeUpdater 
          tableName="clients" 
          onUpdate={() => {}} 
          showStatus={true}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {clientStatuses.map((status) => {
              const count = clients.filter(client => client.status === status.status_key).length;
              return (
                <DynamicCard
                  key={status.id}
                  title={status.name_ar}
                  description={status.name_en}
                  badge={{
                    text: count.toString(),
                    color: status.color
                  }}
                  hoverEffect="lift"
                  pulseOnUpdate
                  className="bg-white/80 backdrop-blur-sm border border-slate-200 hover:border-slate-300 transition-all duration-300 hover:shadow-lg"
                >
                  <div className="flex items-center justify-between">
                    <div className="text-3xl font-bold" style={{ color: status.color }}>
                      {count}
                    </div>
                    <div 
                      className="w-12 h-12 rounded-full flex items-center justify-center"
                      style={{ backgroundColor: `${status.color}20` }}
                    >
                      <Users className="w-6 h-6" style={{ color: status.color }} />
                    </div>
                  </div>
                </DynamicCard>
              );
            })}
          </div>
        </RealTimeUpdater>
      )}
    </section>
  );
};